<template>
  <div class="navbar">
    <div class="navbar-container">
      <!-- 左侧Logo和标题 -->
      <div class="logo-container">
        <router-link to="/">
          <img src="@/assets/logo.png" class="navbar-logo" alt="智慧园区平台">
          <span class="logo-title">智慧园区</span>
        </router-link>
      </div>
      
      <!-- 中间导航菜单 -->
      <div class="menu-container" v-if="!isMobile">
        <div class="menu-item" 
             v-for="(item, index) in navMenus" 
             :key="index"
             :class="{active: isActive(item.path)}"
             @click="handleNavClick(item.path)">
          {{ item.title }}
        </div>
      </div>
      
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-button" v-if="isMobile" @click="toggleMobileMenu">
        <el-icon :size="24"><Menu /></el-icon>
      </div>
      
      <!-- 右侧用户菜单 -->
      <div class="right-menu">
        <!-- 通知中心 -->
        <div class="right-menu-item">
          <el-icon :size="20" @click="goToNotifications"><Bell /></el-icon>
        </div>
        
        <!-- 用户头像下拉菜单 -->
        <div class="right-menu-item">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="avatar-container">
              <el-avatar :size="32" :src="userAvatar">{{ displayName.charAt(0) }}</el-avatar>
              <span class="username" v-if="!isMobile">{{ displayName }}</span>
              <el-icon><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="profile">个人中心</el-dropdown-item>
                <el-dropdown-item command="company">企业信息</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    
    <!-- 移动端菜单展开 -->
    <div class="mobile-menu" v-if="isMobile && mobileMenuVisible">
      <div class="mobile-menu-item" 
           v-for="(item, index) in navMenus" 
           :key="index"
           :class="{active: isActive(item.path)}"
           @click="handleNavClick(item.path)">
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/qingyu'
import { Bell, ArrowDown, Menu } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

// 导航菜单项
const navMenus = [
  { title: '首页', path: '/' },
  { title: '园区入驻', path: '/park/application' },
  { title: '信息提报', path: '/service/tibao/list' },
  { title: '企业服务', path: '/report' },
  { title: '我的企业', path: '/user/company' },
  { title: '入驻信息', path: '/park/tenancy' },
  { title: '物业报修', path: '/service/property/repair' },
  { title: '会议预约', path: '/service/property/facility' },
  // { title: '人才服务', path: '/service/talent' }
]

// 移动端菜单状态
const isMobile = ref(window.innerWidth <= 768)
const mobileMenuVisible = ref(false)

// 监听窗口大小变化
const handleResize = () => {
  isMobile.value = window.innerWidth <= 768
  if (!isMobile.value) {
    mobileMenuVisible.value = false
  }
}

onMounted(() => {
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

// 切换移动端菜单显示状态
const toggleMobileMenu = () => {
  mobileMenuVisible.value = !mobileMenuVisible.value
}

// 判断导航项是否激活
const isActive = (path) => {
  return route.path === path || route.path.startsWith(path + '/')
}

// 导航点击处理
const handleNavClick = (path) => {
  router.push(path)
  mobileMenuVisible.value = false
}

// 用户信息
const userInfo = computed(() => {
  console.log('当前用户信息:', userStore.userInfo)
  return userStore.userInfo
})
const userAvatar = computed(() => {
  console.log('用户头像:', userInfo.value?.avatar)
  return userInfo.value?.avatar || ''
})

// 用户显示名称
const displayName = computed(() => {
  console.log('用户名称:', userInfo.value?.username || userInfo.value?.name || userInfo.value?.nickname)
  return userInfo.value?.username || userInfo.value?.name || userInfo.value?.nickname || '未登录'
})

// 前往通知页面
const goToNotifications = () => {
  router.push('/service/announcement')
}

// 处理下拉菜单命令
const handleCommand = async (command) => {
  if (command === 'logout') {
    try {
      await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      
      await userStore.clearUserInfo()
      router.push('/login')
    } catch (error) {
      // 用户取消操作
    }
  } else if (command === 'profile') {
    router.push('/user/profile')
  } else if (command === 'company') {
    router.push('/user/company')
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
}

.navbar-container {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
}

.logo-container {
  display: flex;
  align-items: center;
  
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
  }
  
  .navbar-logo {
    width: 36px;
    height: 36px;
    margin-right: 10px;
  }
  
  .logo-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
}

.menu-container {
  display: flex;
  align-items: center;
  height: 100%;
  
  .menu-item {
    padding: 0 16px;
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    color: #333;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      color: var(--el-color-primary);
    }
    
    &.active {
      color: var(--el-color-primary);
      font-weight: 500;
      
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        height: 3px;
        background-color: var(--el-color-primary);
        border-radius: 2px;
      }
    }
  }
}

.right-menu {
  display: flex;
  align-items: center;
  
  .right-menu-item {
    margin-left: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    
    &:first-child {
      margin-left: 0;
    }
    
    .notification-icon {
      font-size: 20px;
      color: #666;
      cursor: pointer;
      
      &:hover {
        color: var(--el-color-primary);
      }
    }
  }
  
  .avatar-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    
    .username {
      margin: 0 8px;
      font-size: 14px;
      color: #333;
      max-width: 80px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.mobile-menu-button {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #333;
}

.mobile-menu {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  
  .mobile-menu-item {
    padding: 12px 20px;
    font-size: 15px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    
    &:hover, &.active {
      color: var(--el-color-primary);
      background-color: #f9f9f9;
    }
  }
}

@media screen and (max-width: 768px) {
  .navbar-container {
    padding: 0 15px;
  }
  
  .logo-container {
    .logo-title {
      font-size: 16px;
    }
    
    .navbar-logo {
      width: 32px;
      height: 32px;
    }
  }
}
</style> 
